import { getCurrentUserAttributes, getUserRoles } from '@edge/spark/io-roles'
import { QueryResolvers } from '../../../../../generated/graphql'

export const profileResolver: QueryResolvers['profile'] = async (_, __, { client }) => {
    console.debug('profileResolver deprecated, use getCurrentUserAttributes')
    const profile = await getCurrentUserAttributes({ client })
    const roles = await getUserRoles({ client })

    return {
        __typename: 'Profile',
        roles,
        ...profile,
    }
}
